module.exports = __webpack_public_path__ + "img/leopard.e2dfd4d3.gif";